var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayFillSf = function SvgPlayFillSf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 13,
    viewBox: "0 0 12.5 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 0.9 L11.4 6.5 L1.1 12.1 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
};
export default SvgPlayFillSf;